var a = (n, c, o) => new Promise((i, s) => {
  var d = (e) => {
    try {
      m(o.next(e));
    } catch (t) {
      s(t);
    }
  }, l = (e) => {
    try {
      m(o.throw(e));
    } catch (t) {
      s(t);
    }
  }, m = (e) => e.done ? i(e.value) : Promise.resolve(e.value).then(d, l);
  m((o = o.apply(n, c)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import v from "./receiveAddress.ce.vue.js";
import { vCopyVueucStylesToShadowDom as C } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as _, useTemplateRef as g, withDirectives as h, openBlock as y, createBlock as R, withCtx as p, createVNode as f } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as N } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as r } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import A from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import I from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const M = /* @__PURE__ */ _({
  __name: "index.ce",
  setup(n, { expose: c }) {
    const o = g("receiveAddressRefs");
    let i = null;
    const s = N(), d = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, l = (e) => a(this, null, function* () {
      var t;
      return (t = o.value) == null || t.open({
        serviceId: e.serviceId || "",
        // 963412911815598081
        selectedItemId: e.selectedItemId || "",
        // 1738097915894226946
        receiver: e.receiver || "",
        receiverTel: e.receiverTel || "",
        receiverRegion: e.receiverRegion || "",
        receiverRegionPids: e.receiverRegionPids || "",
        receiveAddress: e.receiveAddress || "",
        address: e.address || "",
        regionName: e.regionName || ""
      }), new Promise((u) => {
        i = u;
      });
    }), m = (e) => {
      i && (i(e), i = null);
    };
    return c({ open: l }), (e, t) => h((y(), R(r(A), {
      locale: r(P),
      "date-locale": r(w),
      "theme-overrides": d,
      "style-mount-target": r(s)
    }, {
      default: p(() => [
        f(r(I), { to: r(s) }, {
          default: p(() => [
            f(v, {
              ref_key: "receiveAddressRefs",
              ref: o,
              onSubmit: m
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [r(C), r(s)]
    ]);
  }
});
export {
  M as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/receive-address/index.ce.vue2.js
// module id = 1276
// module chunks = 41